import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../../Providers/AuthProvider";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import UpdateTourFormThirdStep from "../UpdateTourForm/UpdateTourFormThirdStep";
import { GetPackageDailyScheduleService } from "../../services/GetPackageDailyScheduleService";
import UpdatePackageScheduleDaysService from "../../services/UpdatePackageScheduleDays";
import "animate.css";
import TrackVisibility from "react-on-screen";
import ContentLoading from "../Loading/Loading";
import { goToTop } from "../../utiles/GotoTop";

const ManageTourForthStep = ({ nextStepTab, prevStepTab }) => {
  const [submitTracker, setSubmitTracker] = useState(0);
  const [stepFlag, setStepFlag] = useState(false);
  const nextStepFlag = (flag) => {
    setStepFlag(flag);
  };
  const [changeDay, setChangeDay] = useState({ value: "1", label: "روز اول" });
  const [tour, setTour] = useState({
    DayNumber: { value: "1", label: "روز اول" },
    Plan: "",
    Title: "",
    Id: "",
    Included: "",
    NotIncluded: "",
  });
  const chnageTourHandler = (name, value) => {
    setTour({ ...tour, [name]: value });
  };
  const [includedPlanList, setIncludedPlanList] = useState([]);
  const [notIncludedPlanList, setNotIncludedPlanList] = useState([]);

  const includedPlanListHandler = (item) => {
    setIncludedPlanList([...includedPlanList, item]);
  };
  const includedPlanListRemoveHandler = (id) => {
    const fiteredList = includedPlanList.filter((item) => item.id !== id);
    setIncludedPlanList(fiteredList);
  };
  const notIncludedPlanListListHandler = (item) => {
    setNotIncludedPlanList([...notIncludedPlanList, item]);
  };
  const notIncludedPlanListRemoveHandler = (id) => {
    const fiteredList = notIncludedPlanList.filter((item) => item.id !== id);
    setNotIncludedPlanList(fiteredList);
  };

  const [error, setError] = useState(null);
  const { stateAuth } = useAuth();
  const [loading, setLoading] = useState(true);
  let params = useParams();
  // const [searchParams, setSearchParams] = useSearchParams();
  // const id = searchParams.get("id");
  // console.log(id);

  const changedInputHandler = (value) => {
    setChangeDay(value);
  };

  useEffect(() => {
    const requestData = {
      PackageId: params.id,
      DayNumber: changeDay.value,
    };
    const GetPackageDailySchedule = async () => {
      setTour({
        DayNumber: changeDay,
        Plan: "",
        Title: "",
        Included: "",
        NotIncluded: "",
      });
      setIncludedPlanList([]);
      setNotIncludedPlanList([]);
      const header = {
        headers: {
          token: stateAuth,
        },
      };
      try {
        const { data } = await GetPackageDailyScheduleService(
          requestData,
          header
        );
        if (data) {
          setTour({
            DayNumber: Dayoptions[parseInt(data.Day) - 1],
            Plan: data.DescriptionBR,
            Title: data.TitleSR,
            Included: data.IncludedSR,
            NotIncluded: data.NotIncludedSR,
          });
        }
        setLoading(false);
        formik.resetForm();
      } catch (error) {
        console.log(error);
      }
    };
    GetPackageDailySchedule();
  }, [submitTracker, changeDay]);

  useEffect(() => {
    let PackageIncludedArray = [];
    let PackageNotIncludedArray = [];
    const resultIncluded = [];
    const resultNotIncluded = [];
    if (tour.Included) {
      let PackageNotIncludedText = tour.Included;
      const re = /\s*(?:,|$)\s*/;
      PackageIncludedArray = PackageNotIncludedText.split(re);
      PackageIncludedArray.pop();
      PackageIncludedArray.forEach((item) => {
        resultIncluded.push({
          id: Math.floor(Math.random() * 1000),
          title: item,
        });
      });
      setIncludedPlanList(resultIncluded);
    }
    if (tour.NotIncluded) {
      let PackageIncludedText = tour.NotIncluded;
      const re = /\s*(?:,|$)\s*/;
      PackageNotIncludedArray = PackageIncludedText.split(re);
      PackageNotIncludedArray.pop();
      PackageNotIncludedArray.forEach((item) => {
        resultNotIncluded.push({
          id: Math.floor(Math.random() * 1000),
          title: item,
        });
      });
      setNotIncludedPlanList(resultNotIncluded);
    }
  }, [tour.Included, tour.NotIncluded, tour.DayNumber]);

  /*************** formik **************/
  const Dayoptions = [
    { value: "1", label: "روز اول" },
    { value: "2", label: "روز دوم" },
    { value: "3", label: "روز سوم" },
    { value: "4", label: "روز چهارم" },
    { value: "5", label: "روز پنجم" },
    { value: "6", label: "روز ششم" },
    { value: "7", label: "روز هفتم" },
    { value: "8", label: "روز هشتم" },
    { value: "9", label: "روز نهم" },
    { value: "10", label: "روز دهم" },
    { value: "11", label: "روز یازدهم" },
    { value: "12", label: "روز دوازدهم" },
    { value: "13", label: "روز سیزدهم" },
    { value: "14", label: "روز چهاردهم" },
    { value: "15", label: "روز پانزدهم" },
    { value: "16", label: "روز شانزدهم" },
    { value: "17", label: "روز هفدهم" },
    { value: "18", label: "روز هجدهم" },
    { value: "19", label: "روز نوزدهم" },
    { value: "20", label: "روز بیستم" },
  ];

  const initialValues = {
    DayNumber: tour.DayNumber,
    Plan: tour.Plan,
    Title: tour.Title,
    Included: includedPlanList,
    NotIncluded: notIncludedPlanList,
  };
  const onSubmit = async (values) => {
    const { DayNumber, Plan, Title, Included, NotIncluded } = values;

    const userData = {
      DayNumber: DayNumber.value,
      Plan: btoa(unescape(encodeURIComponent(Plan))),
      Title,
      Included: Included.map(function (el) {
        return el.title + " ";
      }).toString(),
      NotIncluded: NotIncluded.map(function (el) {
        return el.title + " ";
      }).toString(),
      PackageId: params.id,
    };

    try {
      const header = {
        headers: {
          token: stateAuth,
        },
      };
      const { data } = await UpdatePackageScheduleDaysService(userData, header);
      setSubmitTracker(submitTracker + 1);
      if (stepFlag) {
        nextStepTab();
      }
      setLoading(true);
      toast.success(`برنامه زمانی سفر با موفقیت ثبت شد.`);
      formik.resetForm();
      goToTop();
    } catch (error) {
      if (error.response && error.response.data.message) {
        setError(error.response.data.message);
        toast.error(error);
        goToTop();
      }
    }
  };
  const validationSchema = Yup.object({
    DayNumber: Yup.object().required("لطفا ظرفیت تور را وارد نمایید."),
    Title: Yup.string().required("لطفا قیمت بزرگسال را وارد نمایید."),
  });

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
    enableReinitialize: true,
  });
  return !loading ? (
    <TrackVisibility once>
      {({ isVisible }) =>
        isVisible && (
          <form
            className="flex flex-wrap justify-start items-start animate__animated animate__fadeIn"
            onSubmit={formik.handleSubmit}
          >
            <UpdateTourFormThirdStep
              formik={formik}
              Dayoptions={Dayoptions}
              includedPlanList={includedPlanList}
              notIncludedPlanList={notIncludedPlanList}
              includedPlanListHandler={includedPlanListHandler}
              includedPlanListRemoveHandler={includedPlanListRemoveHandler}
              notIncludedPlanListListHandler={notIncludedPlanListListHandler}
              notIncludedPlanListRemoveHandler={
                notIncludedPlanListRemoveHandler
              }
              chnageTourHandler={chnageTourHandler}
              changedInput={changedInputHandler}
              descriptionValue={tour.Plan}
              nextStepFlag={nextStepFlag}
              prevStepTab={prevStepTab}
            />
            {error && <p style={{ color: "red" }}>{error}</p>}
          </form>
        )
      }
    </TrackVisibility>
  ) : (
    <ContentLoading />
  );
};

export default ManageTourForthStep;
